import React from 'react';
import { connect } from 'react-redux';

// node
import Icon from '@mdi/react';
import { mdiHelpCircle, mdiInformationOutline } from '@mdi/js';

// Components
import Tooltip from '../Tooltip';

// utils
import { numberFormat } from '../../utils';

// styles
import { Summary, Price } from './style';

// IDs de tipo_pagamento (tb_tipo_pagamento)
const TIPO_PAGAMENTO_CREDITO = '4';
const TIPO_PAGAMENTO_PIX = '13';

// Percentual de desconto no Pix (apenas para exibição).
const PERCENTUAL_DESCONTO_PIX = 0.05;

const SummaryCart = ({
  summary,
  getSaldoPayment,
  verificaMultiploPagamento,
  getTypePayment,
}) => {
  if (!summary) {
    return '';
  }

  const isCreditApplied = verificaMultiploPagamento.multiplePayments;
  const verifyTypePayment = getTypePayment.tipo_pagamento === TIPO_PAGAMENTO_CREDITO;
  const verifyTypePix = getTypePayment.tipo_pagamento === TIPO_PAGAMENTO_PIX;

  const baseDescontoPix =
    (summary.impressao || 0) +
    (summary.acabamentos || 0) +
    (summary.servicos || 0);

  const descontoPixPreview = baseDescontoPix * PERCENTUAL_DESCONTO_PIX;

  // cliente SEM cupom mostra preview de economia
  const mostrarPreviewPix = !summary.cupom && descontoPixPreview > 0;

  // cliente COM cupom E selecionou Pix avisa sobre não-cumulatividade
  const mostrarAvisoCupomPix = summary.cupom && verifyTypePix;

  function getTotal() {
    if (getSaldoPayment.saldo >= summary.total) {
      return 0;
    }
    if (summary.total > getSaldoPayment.saldo) {
      return summary.total - getSaldoPayment.saldo;
    }
  }

  function showDiscountCredit() {
    if (getSaldoPayment.saldo >= summary.total) {
      return summary.total;
    } else if (getSaldoPayment.saldo < summary.total) {
      return getSaldoPayment.saldo;
    }
  }

  return (
    <Summary>
      <ul>
        {summary.impressao ? (
          <li>
            <span>SubTotal</span>
            <span>R$ {numberFormat(summary.impressao)}</span>
          </li>
        ) : (
          ''
        )}
        {summary.acrescimo.valor ? (
          <li>
            <span>
              Acréscimo
              <Tooltip
                dataId={summary.acrescimo.tipo}
                text={summary.acrescimo.descricao}
                icon={<Icon path={mdiHelpCircle} size={0.8} />}
              />
            </span>
            <span>R$ {numberFormat(summary.acrescimo.valor)}</span>
          </li>
        ) : (
          ''
        )}
        {summary.acabamentos ? (
          <li>
            <span>Acabamentos</span>
            <span>R$ {numberFormat(summary.acabamentos)}</span>
          </li>
        ) : (
          ''
        )}
        {summary.servicos ? (
          <li>
            <span>Serviços Opcionais</span>
            <span>R$ {numberFormat(summary.servicos)}</span>
          </li>
        ) : (
          ''
        )}
        {summary.peso_total ? (
          <li>
            <span>Peso Total</span>
            <span>
              {numberFormat(summary.peso_total)} {summary.unidade_peso}
            </span>
          </li>
        ) : (
          ''
        )}
        {summary.entrega ? (
          <li>
            <span>Frete</span>
            <span>R$ {numberFormat(summary.entrega)}</span>
          </li>
        ) : (
          ''
        )}
        {summary.cupom ? (
          <li>
            <span>Desconto do cupom</span>
            <span>- R$ {numberFormat(summary.cupom)}</span>
          </li>
        ) : (
          ''
        )}
        {verifyTypePayment || isCreditApplied ? (
          <li>
            <span>Desconto do saldo da carteira</span>
            <span>
              - R$ {numberFormat(showDiscountCredit())}
            </span>
          </li>
        ) : (
          ''
        )}
      </ul>

      <Price>
        <span>Total</span>
        {verifyTypePayment || isCreditApplied ? (
          <span>R$ {numberFormat(getTotal())}</span>
        ) : (
          <span>R$ {numberFormat(summary.total)}</span>
        )}
      </Price>

      {mostrarPreviewPix ? (
        <div className="pix-suggestion">
          <span role="img" aria-label="coração">🧡</span>
          <span className="suggestion-text">
            {' '}Pagando no <strong>Pix</strong> você economiza{' '}
            <strong>R$ {numberFormat(descontoPixPreview)}</strong> (5% OFF){' '}
          </span>
          <span role="img" aria-label="coração">💙</span>
        </div>
      ) : (
        ''
      )}

      {mostrarAvisoCupomPix ? (
        <div className="pix-cupom-warning">
          <Icon path={mdiInformationOutline} size={0.8} />
          <span className="warning-text">
            Você utilizou um cupom de desconto. O benefício de 5% no{' '}
            <strong>Pix</strong> não é cumulativo e não será aplicado neste pedido.
          </span>
        </div>
      ) : (
        ''
      )}

      <a
        className='prazo-link'
        target="_blank"
        without
        rel="noopener noreferrer"
        href="https://instrucoes.fabricadolivro.com.br/perguntas-frequentes/como-contar-o-prazo-ate-receber-os-meus-produtos/"
      >
        Como calcular o prazo
      </a>
    </Summary>
  );
};

const mapStateToProps = state => {
  return {
    summary: state.cart.summaryCart,
    getSaldoPayment: state.payment.payments,
    getTypePayment: state.payment.payment,
    verificaMultiploPagamento: state.payment,
  };
};

export default connect(mapStateToProps, null)(SummaryCart);